import React, { useEffect, useState } from "react";
import { FormListProps } from "interfaces/forms/FormListProps";
import { ApiService } from "services/ApiService";
import { FormDto } from "models/forms/FormDto";
import { Form } from "models/forms/Form";
import { useParams } from "react-router-dom";

const FormList: React.FC<FormListProps> = ({
  ownerId,
  onCreateNew,
  onSelect: onClick,
  useDtos,
  formListCount,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [formList, setFormList] = useState<FormDto[] | Form[]>([]);
  const { teamId } = useParams<{ teamId: string }>();

  useEffect(() => {
    const fetchForms = async () => {
      try {
        if (!teamId) return;

        const response = await ApiService.getForms(ownerId, useDtos);

        if (response.success && response.data) setFormList(response.data);
      } catch (error) {
        console.error("Error fetching forms:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchForms();
  }, [ownerId, useDtos, formListCount]);

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="p-5">
      <h2 className="text-xl font-semibold text-center">Forms</h2>

      {formList.length > 0 ? (
        <div className="grid gap-4 mt-5 grid-cols-1 sm:grid-cols-2">
          {formList.map((form) => (
            <div
              key={form.id}
              onClick={() => onClick(useDtos ? form.id : (form as Form))}
              className="w-full border border-gray-300 rounded-xl p-5 bg-white text-center shadow-md cursor-pointer transform transition-transform duration-200 hover:scale-105 hover:shadow-lg"
            >
              <h4 className="text-md font-medium my-2 break-words">{form.name}</h4>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center mt-5 text-gray-500">No forms found.</p>
      )}

      {useDtos && (
        <div className="text-center mt-6">
          <button
            onClick={onCreateNew}
            className="inline-flex items-center justify-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Create New Form
          </button>
        </div>
      )}
    </div>
  );

};

export default FormList;
